import React from "react";
import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import { SubmitButton } from "../../components/form";
import OutlinedInputComponent from "components/form/outlined-input/OutlinedInput.component";
import { Fragment } from "react";
import {
  strengthColor,
  strengthIndicatorNumFunc,
} from "utils/password-strength";
import { FormControl, Grid, Typography } from "@mui/material";
import { useCallback } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ChangePasswordForm = ({
  errors,
  control,
  isSubmitting = false,
  handleSubmit = () => { },
}) => {
  const { t } = useTranslation()
  const [strength, setStrength] = useState(0);
  const [level, setLevel] = useState({ label: 'Bassa', color: 'red' });
  const changePassword = useCallback((value) => {
    const temp = strengthIndicatorNumFunc(value);
    setStrength(temp);
    setLevel(strengthColor(temp));
  }, []);

  return (
    <Box component="form" noValidate onSubmit={handleSubmit} width={1}>
      <Controller
        name="password"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <Fragment>
            <OutlinedInputComponent
              required={true}
              error={errors?.password}
              type="password"
              label="Password*"
              {...field}
              onChange={(e) => {
                field.onChange(e);
                changePassword(e.target.value);
              }}
            />
          </Fragment>
        )}
      />

      {strength !== 0 && (
        <FormControl fullWidth>
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Box
                  style={{ backgroundColor: level?.color }}
                  sx={{
                    width: 85,
                    height: 8,
                    borderRadius: "7px",
                  }}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1" fontSize="0.75rem">
                  {level?.label}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </FormControl>
      )}

      <Controller
        name="matchingPassword"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <OutlinedInputComponent
            required={true}
            error={errors?.matchingPassword}
            label={`${t('Confirm password')}*`}
            type="password"
            {...field}
          />
        )}
      />

      <SubmitButton label={t('Edit')} isSubmitting={isSubmitting} />
    </Box>
  );
};

export default ChangePasswordForm;
